export const MiraimaHero = () => (
  <svg width="125" height="120" viewBox="0 0 125 120" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M110.767 43.9231C110.855 29.1949 108.824 4.69116 94.4444 3.8087C81.8026 3.02885 72.0203 14.665 66.3492 23.777C64.6459 23.6675 62.922 23.5991 61.1776 23.5991C59.3443 23.5991 57.5383 23.6675 55.7529 23.7907C50.0818 14.6787 40.2995 3.02885 27.6509 3.8087C13.1689 4.698 11.2124 29.5369 11.3287 44.231C5.56878 51.0649 2.22363 59.1576 2.22363 67.8385C2.22363 92.2739 13.0731 111.791 61.1776 112.085C109.706 112.386 120.132 92.2739 120.132 67.8385C120.132 59.0208 116.684 50.8186 110.767 43.9231Z"
      fill="url(#paint0_linear_130_21206)"
    />
    <path
      d="M18.1157 17.4751C19.476 13.0537 22.8767 5.16505 31.0383 6.25327C39.1999 7.34148 40.2201 9.99495 41.5804 10.6743"
      stroke="white"
      stroke-width="4.76095"
      stroke-linecap="round"
    />
    <path
      d="M80.6835 10.6783C84.3802 7.89734 93.7583 2.62563 99.7269 8.29767C103.663 12.0379 104.149 15.0985 105.509 18.1591"
      stroke="white"
      stroke-width="4.76095"
      stroke-linecap="round"
    />
    <path
      d="M111.146 43.9231C111.235 29.1949 109.203 4.69116 94.8238 3.8087C82.182 3.02885 72.3997 14.665 66.7286 23.777C65.0253 23.6675 63.3014 23.5991 61.557 23.5991C59.7237 23.5991 57.9177 23.6675 56.1322 23.7907C50.4612 14.6787 40.6789 3.02885 28.0303 3.8087C13.5483 4.698 11.5918 29.5369 11.7081 44.231C5.94818 51.0649 2.60303 59.1576 2.60303 67.8385C2.60303 90.4812 13.4525 111.791 61.557 112.085C110.086 112.386 120.511 92.2739 120.511 67.8385C120.511 59.0208 117.063 50.8186 111.146 43.9231Z"
      stroke="#4B57FF"
      stroke-width="2.76896"
      stroke-miterlimit="10"
    />
    <path
      d="M37.0707 117.295C42.7114 117.295 47.284 113.54 47.284 108.908C47.284 104.276 42.7114 100.521 37.0707 100.521C31.4301 100.521 26.8574 104.276 26.8574 108.908C26.8574 113.54 31.4301 117.295 37.0707 117.295Z"
      fill="url(#paint1_linear_130_21206)"
    />
    <path
      d="M47.2948 108.752C47.2948 113.384 42.7251 117.139 37.0815 117.139C31.4378 117.139 26.8682 113.384 26.8682 108.752C26.8682 107.596 27.1555 106.488 27.6685 105.489"
      stroke="#4B57FF"
      stroke-width="2.76896"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      d="M89.0312 101.479C95.2157 101.479 99.7636 105.551 99.7637 110.054C99.7637 114.557 95.2157 118.629 89.0312 118.629C82.8468 118.629 78.2988 114.557 78.2988 110.054C78.2989 105.551 82.8469 101.479 89.0312 101.479Z"
      fill="#8FA4FF"
      stroke="#4B57FF"
      stroke-width="2.66038"
    />
    <path
      d="M62.126 72.8789C62.126 74.4249 60.8742 75.6768 59.3282 75.6768C57.7821 75.6768 56.5303 74.4249 56.5303 72.8789"
      stroke="#4B57FF"
      stroke-width="1.36816"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      d="M67.7559 72.8789C67.7559 74.4249 66.5041 75.6768 64.958 75.6768C63.412 75.6768 62.1602 74.4249 62.1602 72.8789"
      stroke="#4B57FF"
      stroke-width="1.36816"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      d="M85.5852 80.7861C92.6011 80.7861 98.2886 73.1139 98.2886 63.6499C98.2886 54.1858 92.6011 46.5137 85.5852 46.5137C78.5693 46.5137 72.8818 54.1858 72.8818 63.6499C72.8818 73.1139 78.5693 80.7861 85.5852 80.7861Z"
      fill="url(#paint2_linear_130_21206)"
      stroke="#4B57FF"
      stroke-width="1.33019"
      stroke-miterlimit="10"
    />
    <path
      d="M85.717 76.1083C90.4396 76.1083 94.268 70.5954 94.268 63.7949C94.268 56.9944 90.4396 51.4814 85.717 51.4814C80.9944 51.4814 77.166 56.9944 77.166 63.7949C77.166 70.5954 80.9944 76.1083 85.717 76.1083Z"
      fill="url(#paint3_linear_130_21206)"
    />
    <path
      d="M90.3323 58.701L92.2203 59.3988C93.137 59.7408 93.137 61.0406 92.2203 61.3758L90.3323 62.0735C90.0449 62.183 89.8123 62.4087 89.7097 62.696L89.012 64.5841C88.6699 65.5008 87.3702 65.5008 87.035 64.5841L86.3372 62.696C86.2278 62.4087 86.002 62.1761 85.7147 62.0735L83.8267 61.3758C82.91 61.0337 82.91 59.734 83.8267 59.3988L85.7147 58.701C86.002 58.5915 86.2346 58.3658 86.3372 58.0785L87.035 56.1904C87.377 55.2738 88.6768 55.2738 89.012 56.1904L89.7097 58.0785C89.8192 58.3658 90.0449 58.5984 90.3323 58.701Z"
      fill="#FFFCCD"
    />
    <path
      d="M38.5637 80.7861C45.5796 80.7861 51.2671 73.1139 51.2671 63.6499C51.2671 54.1858 45.5796 46.5137 38.5637 46.5137C31.5478 46.5137 25.8604 54.1858 25.8604 63.6499C25.8604 73.1139 31.5478 80.7861 38.5637 80.7861Z"
      fill="url(#paint4_linear_130_21206)"
      stroke="#4B57FF"
      stroke-width="1.33019"
      stroke-miterlimit="10"
    />
    <path
      d="M38.8584 76.1083C43.7699 76.1083 47.7514 70.5954 47.7514 63.7949C47.7514 56.9944 43.7699 51.4814 38.8584 51.4814C33.9469 51.4814 29.9653 56.9944 29.9653 63.7949C29.9653 70.5954 33.9469 76.1083 38.8584 76.1083Z"
      fill="url(#paint5_linear_130_21206)"
    />
    <path
      d="M43.3181 58.701L45.2061 59.3988C46.1228 59.7408 46.1228 61.0406 45.2061 61.3758L43.3181 62.0735C43.0308 62.183 42.7982 62.4087 42.6956 62.696L41.9978 64.5841C41.6558 65.5008 40.356 65.5008 40.0208 64.5841L39.3231 62.696C39.2136 62.4087 38.9879 62.1761 38.7006 62.0735L36.8125 61.3758C35.8958 61.0337 35.8958 59.734 36.8125 59.3988L38.7006 58.701C38.9879 58.5915 39.2205 58.3658 39.3231 58.0785L40.0208 56.1904C40.3629 55.2738 41.6626 55.2738 41.9978 56.1904L42.6956 58.0785C42.805 58.3658 43.0308 58.5984 43.3181 58.701Z"
      fill="#FFFCCD"
    />
    <defs>
      <linearGradient
        id="paint0_linear_130_21206"
        x1="61.1776"
        y1="3.77148"
        x2="61.1776"
        y2="112.088"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#DFF0FF" />
        <stop offset="1" stop-color="#899FFF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_130_21206"
        x1="37.0707"
        y1="100.521"
        x2="37.0707"
        y2="117.295"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#90A6FF" />
        <stop offset="1" stop-color="#7A8EF7" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_130_21206"
        x1="85.5852"
        y1="74.2257"
        x2="85.5852"
        y2="47.2593"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FFFCCD" />
        <stop offset="1" stop-color="#85FCFB" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_130_21206"
        x1="85.717"
        y1="52.4365"
        x2="85.717"
        y2="76.0265"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#541DD5" />
        <stop offset="1" stop-color="#4D57F6" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_130_21206"
        x1="38.5637"
        y1="74.2257"
        x2="38.5637"
        y2="47.2593"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FFFCCD" />
        <stop offset="1" stop-color="#85FCFB" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_130_21206"
        x1="38.8584"
        y1="52.4365"
        x2="38.8584"
        y2="76.0265"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#541DD5" />
        <stop offset="1" stop-color="#4D57F6" />
      </linearGradient>
    </defs>
  </svg>
);
